import {
  TASKDETAIL_LOADING,
  GET_TASKDETAIL,
  GET_TASKDETAIL_SUCCESS,
  GET_TASKDETAIL_FAIL,
  ADD_TASKDETAIL_SUCCESS,
  ADD_TASKDETAIL_FAIL,
  DELETE_TASKDETAIL_SUCCESS,
  DELETE_TASKDETAIL_FAIL,
  UPDATE_TASKDETAIL_SUCCESS,
  UPDATE_TASKDETAIL_FAIL,
  TASKDETAIL_RESET
} from "./actionType";

const INIT_STATE = {
  taskDetails: [],
  error: {},
};

const TaskDetail = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_TASKDETAIL_SUCCESS:
      switch (action.payload.actionType) {
        case GET_TASKDETAIL:
          return {
            ...state,
            taskDetails: action.payload.data,
            isTaskDetailCreated: false,
            isTaskDetailSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_TASKDETAIL_FAIL:
      switch (action.payload.actionType) {
        case GET_TASKDETAIL_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isTaskDetailCreated: false,
            isTaskDetailSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_TASKDETAIL: {
      return {
        ...state,
        isTaskDetailCreated: false,
        loading: true,
      };
    }

    case TASKDETAIL_LOADING: {
      return {
        ...state,
        isTaskDetailCreated: false,
        loading: true,
      };
    }

    case ADD_TASKDETAIL_SUCCESS:
      return {
        ...state,
        isTaskDetailCreated: true,
        loading: false,
        taskDetails: [action.payload.data, ...state.taskDetails],
      };

    case ADD_TASKDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_TASKDETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        taskDetails: state.taskDetails.filter(
          taskDetail => taskDetail.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_TASKDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_TASKDETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        taskDetails: state.taskDetails.map(taskDetail =>
          taskDetail.id.toString() === action.payload.data.id.toString() ? { ...taskDetail, ...action.payload.data } : taskDetail
        ),
      };

    case UPDATE_TASKDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case TASKDETAIL_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default TaskDetail;